import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

/** Keeps image space reserved and provides a quiet placeholder while it loads. */
export default function LoadingImage({ src, alt = '', sx, ...props }) {
  const [loaded, setLoaded] = React.useState(false);

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden', ...sx }}>
      {!loaded && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          aria-hidden="true"
          sx={{ position: 'absolute', inset: 0, zIndex: 1 }}
        />
      )}
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        sx={{
          display: 'block',
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 180ms ease-in',
        }}
        {...props}
      />
    </Box>
  );
}
